import React from "react";
import { useIntl } from "react-intl";

import { StepWrapper } from "../../components/StepWrapper";
import { messages } from "./messages";
import { ProductTypesTab } from "./ProductTypesTab";

const BRANDS_FORM_ID = "wizard-catalog-brands-form";

export const CatalogStep: React.FC = () => {
  const intl = useIntl();

  return (
    <StepWrapper
      title={intl.formatMessage(messages.title)}
      description={intl.formatMessage(messages.description)}
      skippable={true}
      formId={BRANDS_FORM_ID}
    >
      <ProductTypesTab formId={BRANDS_FORM_ID} />
    </StepWrapper>
  );
};
